import "./ReferringProviders.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import ReferralInformation from "./sections/ReferralInformation";
import CommonReasonsForReferral from "./sections/CommonReasonsForReferral";
import HowToSendAReferral from "./sections/HowToSendAReferral";
import ClosingCta from "./sections/ClosingCta";
import Providerreferralcta from "./sections/Providerreferralcta";
import Footer from "@/reusable_sections/Footer";
export default function ReferringProvidersPage() {
  return <div>
      <Header />
      <Hero />
      <ReferralInformation />
      <CommonReasonsForReferral />
      <HowToSendAReferral />
      <ClosingCta />
      <Providerreferralcta />
      <Footer />
    </div>;
}